// P0 Pre-launch Pricing · FASE D · Paywall upsell card riusabile.
// -----------------------------------------------------------------------------
// Fallback standard per `<FeatureGate featureKey="..." fallback={<PaywallUpsellCard />}>`.
// Lock icon + testo "Funzionalità premium" + CTA /pricing.
// V12 Achromatic Strict · reusable across all gated pages.
import React from "react";
import { Lock, ArrowRight } from "lucide-react";
import { requiredPlanFor } from "@/data/plan_feature_gating";


const TIER_LABEL = {
    trial: "Trial",
    starter: "Starter",
    growth: "Growth",
    scale: "Scale",
    enterprise: "Enterprise",
};


export default function PaywallUpsellCard({ featureKey, title, description }) {
    const required = (featureKey && requiredPlanFor(featureKey)) || "growth";
    const tierLabel = TIER_LABEL[required] || required;
    return (
        <div
            className="min-h-[60vh] flex items-center justify-center bg-black px-6 py-16"
            data-testid={`paywall-upsell-${featureKey || "generic"}`}
            data-feature-key={featureKey || ""}
            data-required-plan={required}
        >
            <div className="max-w-md w-full rounded-2xl border border-[#1A1A1A] bg-[#060606] p-8 text-center">
                <div className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full border border-[#2A2A2A] bg-black">
                    <Lock className="h-6 w-6 text-white/60" />
                </div>
                <h2 className="text-xl font-semibold text-white" data-testid="paywall-upsell-title">
                    {title || "Funzionalità premium"}
                </h2>
                <p className="mt-2 text-sm text-white/60" data-testid="paywall-upsell-description">
                    {description || `Disponibile dal piano ${tierLabel}.`}
                </p>
                <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
                    <a
                        href="/pricing"
                        data-testid="paywall-upsell-cta-pricing"
                        className="inline-flex items-center justify-center gap-1 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-black hover:bg-white/90"
                    >
                        Scopri i piani <ArrowRight className="h-3.5 w-3.5" />
                    </a>
                    <a
                        href="/contact-sales"
                        data-testid="paywall-upsell-cta-contact"
                        className="inline-flex items-center justify-center rounded-full border border-[#2A2A2A] px-5 py-2.5 text-sm text-white hover:border-white"
                    >
                        Parla con noi
                    </a>
                </div>
                <p className="mt-6 text-[10px] uppercase tracking-widest text-white/30">
                    Richiesto: piano {tierLabel}
                </p>
            </div>
        </div>
    );
}
